export default "__VITE_ASSET__07ab4327__"